
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
export default defineComponent({
  data() {
    return {
      getReady: false,
    };
  },
  computed: {
    ...mapGetters({
      currentRound: "getCurrentRound",
      hasTurns: "getHasTurns",
    }),
  },
  mounted() {
    if (!this.hasTurns) {
      setTimeout(() => {
        this.getReady = true;
      }, 1900);
    }
  },
});
